import React, { useState } from "react";
import Carousel from "./Carousel";
import { useLocation, useNavigate } from "react-router-dom";
import { verifyOtpService } from "../../api/services/authServices";
import { toast } from "react-toastify";

const OtpVerification = () => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const navigate = useNavigate();
    const { state } = useLocation();

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^\d*$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            const nextInput = document.getElementById(`otp-${index + 1}`);
            nextInput?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            const prevInput = document.getElementById(`otp-${index - 1}`);
            prevInput?.focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fullOtp = otp.join("");
        let response = await verifyOtpService({ otp: fullOtp ,userId: state.userId });
        if (response.status === 200) {
            toast.success("OTP verified successfully");
            navigate("/sign-in");
        } else {
            toast.error("Invalid OTP");
        }
    };

    return (
        <div className="flex min-h-screen">
            <div className="w-[30%] hidden md:block">
                <Carousel />
            </div>

            <div className="w-full md:w-[70%] flex items-center justify-center px-4">
                <form
                    onSubmit={handleSubmit}
                    className="bg-white w-full max-w-md p-8 rounded-[15px] [box-shadow:0px_2px_8px_0px_#80808040] space-y-6"
                >
                    <h2 className="text-2xl font-semibold text-center">OTP Verification</h2>
                    <p className="text-center text-sm text-gray-600">
                        Enter the 6-digit code sent to your email
                    </p>

                    <div className="flex justify-between space-x-2">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                id={`otp-${index}`}
                                type="text"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                className="w-12 h-12 text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#56B22F] text-lg"
                            />
                        ))}
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-[#56B22F] text-white py-3 rounded-lg font-semibold hover:bg-[#4a9c28] transition-colors"
                    >
                        Verify
                    </button>

                    <p className="text-center text-sm text-gray-600">
                        Didn’t receive the code?{" "}
                        <span
                            className="text-[#56B22F] font-medium cursor-pointer"
                            onClick={() => console.log("Resend OTP")}
                        >
                            Resend
                        </span>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default OtpVerification;
